export const MAX_SEGMENTS = 10;

export const MAX_SEGMENTATIONS = 2;

export const DEFAULT_SEGMENTS = [
  { id: 1, minValue: 0, maxValue: 50000 },
  { id: 2, minValue: 50000, maxValue: 100000 },
  { id: 3, minValue: 100000, maxValue: 200000 },
  { id: 4, minValue: 200000, maxValue: 300000 },
  { id: 5, minValue: 300000, maxValue: 400000 },
  { id: 6, minValue: 400000, maxValue: 500000 },
  { id: 7, minValue: 500000, maxValue: 600000 },
  { id: 8, minValue: 600000, maxValue: 700000 },
  { id: 9, minValue: 700000, maxValue: 800000 },
  { id: 10, minValue: 800000, maxValue: 900000 },
];

export const FILTERED_COLUMNS = [
  "DATASETID",
  "SOURCEFILEID",
  "CUBEID",
  "WASALREADYMERGEDFROMDATASETS",
  "FX_UNIQUE_ID",
  "isMatchFinalized",
];
